import { Kbd } from "@chakra-ui/react";
import * as React from 'react';
export default {
  Kbd,
  React
};